function watchAndMoveElement() {
  const targetDiv = document.querySelector(
    ".product__size.collection__item-size"
  );

  function findAndMoveSwymButton() {
    const swymButton = document.querySelector(
      ".swym-button-bar.swym-wishlist-button-bar.swym-inject"
    );
    if (swymButton) {
      targetDiv.appendChild(swymButton);
    } else {
      setTimeout(findAndMoveSwymButton, 500);
    }
  }

  findAndMoveSwymButton();

  // wishlistボタンを監視する
  var observer = new MutationObserver(function (mutations) {
    // クリック先をwishlistページに変更したいエレメントを取得
    const headerWishButtom = document.getElementById("swym-inject-header");
    const wishText = document.querySelector(".swym-tooltip-text");
    const notificationWish = document.querySelector(
      ".swym-notification-wishlist"
    );
    if (headerWishButtom) {
      headerWishButtom.style.display = "none";
      changeLinkOfWishButton(headerWishButtom);
    }
    if (wishText) {
      changeLinkOfWishButton(wishText);
    }
    if (notificationWish) {
      changeLinkOfWishButton(notificationWish);
    }

    //全てにイベントを付与できたら、監視を終了
    if (headerWishButtom && wishText && notificationWish) {
      observer.disconnect();
    }
  });

  //モーダルではなく、お気に入りページに遷移する
  function changeLinkOfWishButton(wishButtom) {
    wishButtom.addEventListener(
      "click",
      function (event) {
        // 既存の処理をキャンセル
        event.preventDefault();
        event.stopPropagation();

        // リンク先を変更
        window.location.href = "/pages/wishlist";
      },
      true
    );
  }

  // Start observing the document with the configured parameters
  observer.observe(document, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", watchAndMoveElement);
} else {
  watchAndMoveElement();
}
